import React from 'react';
import { GatsbyImage } from "gatsby-plugin-image";
import { Container, Row, Col } from 'react-bootstrap';

import { hexaToRgba } from '../../components/functions';
import Buttons from '../../components/paragraph/buttons';
import Heading from '../../components/paragraph/heading';
import Video from '../../components/paragraph/video';

export default ({ type }) => {
  return <>
    {type.relationships.field_video && (
      <section
        className={`dark`}
        style={{ position: 'relative', overflow: 'hidden' }}
      >
        {type.relationships.field_video.relationships
          .field_background_image && (
          <GatsbyImage
            image={type.relationships.field_video.relationships
              .field_background_image.relationships
              .field_media_image.localFile.childImageSharp.gatsbyImageData}
            imgStyle={{ objectFit: 'cover' }}
            alt={
              type.relationships.field_video.relationships
                .field_background_image.field_media_image.alt
            }
            style={{
              position: 'absolute',
              minWidth: '100%',
              minHeight: '100%',
              left: '50%',
              top: '50%',
              transform: 'translate(-50%, -50%)',
            }} />
        )}
        {type.relationships.field_video.field_background_color && (
          <div
            style={{
              backgroundColor: `${
                type.relationships.field_video
                  .field_background_color
                  ? hexaToRgba(
                      type.relationships.field_video
                        .field_background_color
                    )
                  : 'initial'
              }`,
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
            }}
          />
        )}
        <Container style={{ position: 'relative' }}>
          <Row className={`justify-content-center`}>
            <Col xs={12} md={10} xl={8}>
              {type.relationships.field_video.relationships
                .field_component_heading && (
                <Heading
                  props={
                    type.relationships.field_video.relationships
                      .field_component_heading
                  }
                />
              )}
            </Col>
            <Col xs={12} md={9} xl={6}>
              <Video
                props={
                  type.relationships.field_video.relationships
                    .field_video
                }
              />
            </Col>
          </Row>
        </Container>
      </section>
    )}

    {type.relationships.field_call_to_action && (
      <section
        className={`dark`}
        style={{ position: 'relative', overflow: 'hidden' }}
      >
        {type.relationships.field_call_to_action
          .field_background_color && (
          <div
            style={{
              backgroundColor: `${
                type.relationships.field_call_to_action
                  .field_background_color
                  ? hexaToRgba(
                      type.relationships.field_call_to_action
                        .field_background_color
                    )
                  : 'initial'
              }`,
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
            }}
          />
        )}
        <Container style={{ position: 'relative' }}>
          <Row className={`justify-content-center`}>
            <Col xs={12} md={10} xl={8}>
              {type.relationships.field_call_to_action.relationships
                .field_component_heading && (
                <Heading
                  props={
                    type.relationships.field_call_to_action
                      .relationships.field_component_heading
                  }
                />
              )}
              {type.relationships.field_call_to_action.relationships
                .field_component_button_s && (
                <Buttons
                  props={
                    type.relationships.field_call_to_action
                      .relationships.field_component_button_s
                  }
                />
              )}
            </Col>
          </Row>
        </Container>
      </section>
    )}
  </>;
};
